const LOG_KEY = 'frontendLogs';
const MAX_ENTRIES = 500;

function safeGet() {
  try { return JSON.parse(localStorage.getItem(LOG_KEY) || '[]'); } catch { return []; }
}

function safeSet(logs) {
  try { localStorage.setItem(LOG_KEY, JSON.stringify(logs)); } catch {}
}

export function appendLog(level, message) {
  const logs = safeGet();
  logs.push({ ts: Date.now(), level, message: String(message) });
  if (logs.length > MAX_ENTRIES) logs.splice(0, logs.length - MAX_ENTRIES);
  safeSet(logs);
}

export function getAllLogs() {
  return safeGet();
}

export function downloadLogs() {
  const logs = getAllLogs();
  const text = logs.map(l => `[${new Date(l.ts).toISOString()}] [${l.level}] ${l.message}`).join('\n');
  const blob = new Blob([text], { type: 'text/plain' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `frontend-logs-${new Date().toISOString().replace(/[:.]/g, '-')}.log`;
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

if (typeof window !== 'undefined') {
  window.downloadFrontendLogs = downloadLogs;
}
